import { BillingPeriod } from "@redotech/redo-model/billing/service-invoice";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export type AeoInvoiceStatus = z.infer<typeof aeoInvoiceStatus>;
export const aeoInvoiceStatus = z.object({
  period: createEnum(BillingPeriod),
  subscriptionPrice: z.number(),
  billingDueDate: z.date(),
  totalInvoiceAmount: z.number(),
});

export const getCurrentAeoInvoice = {
  name: "getCurrentAeoInvoice" as const,
  input: z.null(),
  output: aeoInvoiceStatus.nullable(),
};
